import { loadAuth, getEmailFromToken } from "../lib/auth.js";

export async function whoamiCommand(): Promise<void> {
  const auth = loadAuth();

  if (!auth) {
    console.log("Not logged in");
    return;
  }

  const email = getEmailFromToken(auth.access_token) ?? "unknown";
  console.log(`Email:  ${email}`);
  if (auth.org_id) {
    console.log(`Org:    ${auth.org_id}`);
  }
}
